import { useAuthContext } from "./AuthContext";

/**
 * Returns the current bearer token regardless of which auth provider
 * the user picked. The hook itself is thin — all the provider-aware logic
 * lives in <AuthProvider>. Caller contract (`{ token, getToken }`) is kept
 * so callers like MemberProfilePage continue to work.
 */
export function useActiveAccessToken(): {
  token: string | undefined;
  getToken: () => string | undefined;
} {
  const ctx = useAuthContext();
  return {
    token: ctx.accessToken ?? undefined,
    getToken: () => ctx.getToken() ?? undefined,
  };
}
